// The daemon's busy queue turned an acked prompt or command away: the closed reason codes it puts on the
// "unavailable" verdict (server busy-refusal.ts), and what the row says. A bare "unavailable" is not one
// of them (a bounced send-now row is still live), and none of them offers a retry: a typed command is
// never resent as chat text.
const COPY: Record<string, string> = {
  busy_full: "The agent already had too many messages waiting. This did not run.",
  busy_bound: "The agent stayed busy past the wait limit. This did not run.",
  busy_failed: "The agent could not hold this in line. It did not run.",
  busy_stuck: "The agent did not stop when interrupted. This did not run.",
  busy_lost: "The agent restarted before this could run. It did not run.",
  // A removal is a person's own act (CYBORG-1560): it says so, never "did not run".
  removed_by_author: "You removed this from the queue before it ran.",
  removed_by_controller: "Removed from the queue before it ran.",
  // A restart found the agent's session gone (CYBORG-1560): the DM keeps the words to resend.
  session_closed:
    "The agent's session ended before this ran. Your message is kept below to send again.",
};

export function busyRefusalCopy(reason: string | undefined): string | undefined {
  return reason && Object.hasOwn(COPY, reason) ? COPY[reason] : undefined;
}
